module.exports = __webpack_public_path__ + "static/elizabeth-blog-03-c60203046e39cf69607c5e9c5aab3456.jpg";